export const enum Protocol {
  http = 'http://',
  https = 'https://',
}

export const prefix = Protocol.https;

export const EXTERNAL_URL_PRODUCTION = {
  pague_la: 'https://app.pague.la',
  pague_la_checkout: 'https://novo.pague.la',
  sign_view: 'https://assine.actuar.com',
  hotsite_domain: 'novo.actuar.com',
  link_shortener_actuar: 'https://link.actuar.com/',
  link_shortener_ediz: 'https://link.ediz.com.br/',
  registration_app: 'https://bemvindo.actuar.com',
};

export const APP_URL_PRODUCTION = {
  accounts: prefix + 'accounts.actuar.com',
  actuar_app: prefix + 'novo.actuar.com',
  legacy_app: prefix + 'app.actuar.com',
  treino_app: prefix + 'treino.actuar.dev',
  actuar_sign: prefix + 'sign.actuar.dev',
  afig_app: prefix + 'app.afig.actuar.dev',
  actuar_acesso: prefix + 'acesso.actuar.dev',
  // `app.facilfit.com.br` é o FácilFit **legado** (pacote `main.<hash>.js`, sem
  // nenhuma rota deste monorepo). O front novo está em `novo.facil.fit`, que
  // serve o mesmo release publicado em `novo.actuar.com` — e é para lá que o
  // accounts da marca devolve depois do login (`accounts.facil.fit` →
  // `novo.facil.fit`, por `goRedirect` em `auth.store.ts`).
  facilfit_app: prefix + 'novo.facil.fit',
  face_detection_app: prefix + 'facialid.actuar.com',
  ediz_app: prefix + 'app.ediz.com.br',
  tickou_app: prefix + 'app.tickou.com',
  live_pickup_app: prefix + 'livepickup.ediz.com.br',
  ediz_family_app: prefix + 'app.familia.ediz.com.br',
  live_access_app: prefix + 'liveaccess.actuar.com',
  paguela_v2_app: prefix + 'novo.pague.la',
};

export const API_PRODUCTION_ACTUAR = {
  // Servidores de loopback dos clientes desktop, na máquina do operador. Iguais
  // nos cinco ambientes: a estação é a do operador em todos eles.
  // Contrato: accessedge/docs/integracoes/handoff-front-status-local.md
  edge_desk_status: 'http://localhost:63317/desk/status',
  access_desk_status: 'http://localhost:63318/desk/status',
  print_agent_status: 'http://localhost:63319/printagent/status',
  edge_desk_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/EdgeDesk/EdgeDesk.appinstaller',
  access_desk_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/AccessDesk/AccessDesk.appinstaller',
  print_agent_release:
    'https://prd-desktop-releases.cdn.actuar.cloud/PrintAgent/PrintAgent.appinstaller',
  odata: prefix + 'odata.prd.o.actuar.cloud',
  odata_goods_service: prefix + 'goodservice-api.prd.o.actuar.cloud/Odata',
  odata_person_service: prefix + 'personservice-api.prd.o.actuar.cloud/Odata',
  odata_payable_service: prefix + 'payableservice-api.prd.o.actuar.cloud/Odata',
  odata_work_service: prefix + 'workservice-api.prd.o.actuar.cloud/Odata',
  odata_crm_service: prefix + 'crmservice-api.prd.o.actuar.cloud/Odata',
  odata_generalfinance_service:
    prefix + 'generalfinanceservice-api.prd.o.actuar.cloud/Odata',
  odata_account_service: prefix + 'accountservice-api.prd.o.actuar.cloud/Odata',
  odata_receivable_service:
    prefix + 'receivableservice-api.prd.o.actuar.cloud/Odata',
  odata_email_service: prefix + 'emailservice-api.prd.o.actuar.cloud/Odata',
  odata_contract: prefix + 'contractservice-api.prd.o.actuar.cloud/Odata',
  odata_user_service: prefix + 'userservice-api.prd.o.actuar.cloud/Odata',
  odata_workout_service: prefix + 'workoutservice-api.prd.o.actuar.cloud/Odata',
  odata_post_service: prefix + 'postservice-api.prd.o.actuar.cloud/Odata',
  odata_activity_service:
    prefix + 'activityservice-api.prd.o.actuar.cloud/Odata',
  odata_addresses_service:
    prefix + 'addressservice-api.prd.o.actuar.cloud/Odata',
  odata_booking_service: prefix + 'bookingservice-api.prd.o.actuar.cloud/Odata',
  odata_graduation_service:
    prefix + 'graduationservice-api.prd.o.actuar.cloud/Odata',
  odata_data_service: prefix + 'dataservice-api.prd.o.actuar.cloud/Odata',
  odata_subscription_service:
    prefix + 'subscriptionservice-api.prd.o.actuar.cloud/Odata',
  odata_physical_assessment_service:
    prefix + 'physicalassessmentservice-api.prd.o.actuar.cloud/Odata',
  odata_helpdesk_service:
    prefix + 'helpdeskservice-api.prd.o.actuar.cloud/Odata',
  odata_hotsite_service: prefix + 'hotsiteservice-api.prd.o.actuar.cloud/Odata',
  odata_consumption_log_service:
    prefix + 'consumptionlogservice-api.prd.o.actuar.cloud/Odata',
  odata_access_log_service:
    prefix + 'accesslogservice-api.prd.o.toletus.cloud/Odata',
  odata_filegroup_service:
    prefix + 'filegroupservice-api.prd.o.actuar.cloud/Odata',
  odata_access_service: prefix + 'accessservice-api.prd.o.actuar.cloud/Odata',
  odata_access_flow_service:
    prefix + 'accessflowservice-api.prd.o.toletus.cloud/Odata',
  odata_access_directory_service:
    prefix + 'accessdirectoryservice-api.prd.o.toletus.cloud/Odata',
  odata_school_service: prefix + 'schoolservice-api.prd.o.actuar.cloud/Odata',
  school_service: prefix + 'schoolservice-api.prd.o.actuar.cloud',
  base: prefix + 'actuar-api.prd.o.actuar.cloud',
  paguela: prefix + 'paguela-api.prd.o.actuar.cloud',
  api_cep: prefix + 'cep-api.prd.g.actuar.cloud',
  auth: prefix + 'authentication-api.prd.g.actuar.cloud',
  chat: prefix + 'chat-api.prd.o.actuar.cloud',
  file_manager: prefix + 'filegroup-api.prd.g.actuar.cloud',
  treino: prefix + 'treino-api.prd.g.actuar.cloud',
  facial: prefix + 'facial-api.prd.g.actuar.cloud',
  acesso: prefix + 'acesso-api.prd.o.actuar.cloud',
  caixa: prefix + 'caixa-api.prd.o.actuar.cloud',
  treasury_service: prefix + 'treasuryservice-api.prd.o.actuar.cloud',
  helpdesk: prefix + 'helpdeskservice-api.prd.o.actuar.cloud',
  ajustes: prefix + 'tst.actuar.net/actuar',
  files_api: prefix + 'files-api.prd.g.actuar.cloud',
  contract: prefix + 'contractservice-api.prd.o.actuar.cloud',
  billing: prefix + 'billing-api.prd.o.actuar.cloud',
  gympass: prefix + 'gympass-api.prd.o.actuar.cloud',
  client_notification: prefix + 'clientnotification-api.prd.o.actuar.cloud',
  client_device: prefix + 'clientdeviceservice-api.prd.o.actuar.cloud',
  invoicer: prefix + 'invoicer-api.prd.o.actuar.cloud',
  acessoLocalhost: Protocol.http + 'localhost:63312',
  userService: prefix + 'userservice-api.prd.o.actuar.cloud',
  personService: prefix + 'personservice-api.prd.o.actuar.cloud',
  file_group: prefix + 'filegroup-api.prd.g.actuar.cloud',
  account_service: prefix + 'accountservice-api.prd.o.actuar.cloud',
  goods: prefix + 'goodservice-api.prd.o.actuar.cloud',
  payable_service: prefix + 'payableservice-api.prd.o.actuar.cloud',
  workService: prefix + 'workservice-api.prd.o.actuar.cloud',
  crm_service: prefix + 'crmservice-api.prd.o.actuar.cloud',
  generalfinance_service:
    prefix + 'generalfinanceservice-api.prd.o.actuar.cloud',
  receivable_service: prefix + 'receivableservice-api.prd.o.actuar.cloud',
  subscription_service: prefix + 'subscriptionservice-api.prd.o.actuar.cloud',
  email_service: prefix + 'emailservice-api.prd.o.actuar.cloud',
  workout_service: prefix + 'workoutservice-api.prd.o.actuar.cloud',
  workout_view: prefix + 'workoutviewservice-api.prd.o.actuar.cloud',
  post_service: prefix + 'postservice-api.prd.o.actuar.cloud',
  activity_service: prefix + 'activityservice-api.prd.o.actuar.cloud',
  activity_tracking_service: prefix + 'activitytrackingservice-api.prd.o.actuar.cloud',
  booking_service: prefix + 'bookingservice-api.prd.o.actuar.cloud',
  data_service: prefix + 'dataservice-api.prd.o.actuar.cloud',
  addresses_service: prefix + 'addressservice-api.prd.o.actuar.cloud',
  storage_service: prefix + 'storageservice-api.prd.o.actuar.cloud',
  physical_assessment_service:
    prefix + 'physicalassessmentservice-api.prd.o.actuar.cloud',
  whatsapp_service: prefix + 'whatsappservice-api.prd.o.actuar.cloud',
  graduation_service: prefix + 'graduationservice-api.prd.o.actuar.cloud',
  totalpass: prefix + 'totalpassservice-api.prd.o.actuar.cloud',
  hotsite: prefix + 'hotsite-api.prd.o.actuar.cloud',
  storage: prefix + 'storage-api.prd.o.actuar.cloud',
  search_service: prefix + 'searchservice-api.prd.o.actuar.cloud',
  file_group_service: prefix + 'filegroupservice-api.prd.o.actuar.cloud',
  hotsite_service: prefix + 'hotsiteservice-api.prd.o.actuar.cloud',
  credit_assessment_service:
    prefix + 'creditassessmentservice-api.prd.o.actuar.cloud',
  meetings_service: prefix + 'meetingservice-api.prd.o.actuar.cloud',
  access_service: prefix + 'accessservice-api.prd.o.actuar.cloud',
  access_directory_service:
    prefix + 'accessdirectoryservice-api.prd.o.toletus.cloud',
  consumption_log_service:
    prefix + 'consumptionlogservice-api.prd.o.actuar.cloud',
  consumption_auth_service:
    prefix + 'consumptionauthservice-api.prd.o.actuar.cloud',
  access_edge_manager_service:
    prefix + 'accessedgemanager-api.prd.o.toletus.cloud',
  access_edge_manager_service_grpc:
    prefix + 'grpc.accessedgemanager-api.prd.o.toletus.cloud',
  fingerprint_service: prefix + 'fingerprintservice-api.prd.o.toletus.cloud',
  suggestion_service: prefix + 'suggestionservice-api.prd.cfw.actuar.cloud',
  registration_service: prefix + 'registrationservice-api.prd.cfw.actuar.cloud',
  // weatherservice-api tem deploy unico (producao): o handoff declara que nao ha
  // ambiente de homologacao separado, entao todos os ambientes apontam para o mesmo
  // host — como print_agent_service e suggestion_service. Quando houver stg, o lugar
  // de separar e aqui: o front nunca monta esta URL a mao.
  weather_service: prefix + 'weatherservice-api.prd.o.actuar.cloud',
  academy_service: prefix + 'academyservice-api.prd.o.actuar.cloud',
  odata_academy_service: prefix + 'academyservice-api.prd.o.actuar.cloud/odata',
  migrator_service: prefix + 'migrator-api.prd.g.actuar.cloud',
  spooler: prefix + 'spooler-api.prd.o.actuar.cloud',
  print_agent_service: prefix + 'printagentservice-api.prd.o.toletus.cloud',
  access_edge_provisioning_service:
    prefix + 'accessedgeprovisioning-api.prd.o.toletus.cloud',
  channel_gateway_service: prefix + 'channelgateway-api.prd.g.actuar.cloud',
  odata_channel_gateway_service:
    prefix + 'channelgateway-api.prd.g.actuar.cloud/OData',
  support_service: prefix + 'supportservice-api.prd.o.actuar.cloud',
  ato_service: prefix + 'atoservice-api.prd.o.actuar.cloud',
  access_log_service: prefix + 'accesslogservice-api.prd.o.toletus.cloud',
  access_flow_service: prefix + 'accessflowservice-api.prd.o.toletus.cloud',
  integration_api: prefix + 'api.actuar.com',
  linkbio_service: prefix + 'linkbioworker-api.prd.cfw.actuar.cloud',
  geo_service: prefix + 'geoworker-api.prd.cfw.actuar.cloud',
  // Comunicados — Worker Cloudflare do repo Actuar/announcementsworker-api.
  // MESMA URL nos cinco ambientes: o Worker tem publicacao unica em producao
  // (ADR 0004 de la), sem par de stg/prd. Quando houver, o lugar de separar e
  // aqui — o front nunca monta esta URL a mao.
  announcements_service: prefix + 'announcementsworker-api.prd.cfw.actuar.cloud',
  access_scheduling_service: prefix + 'schedulertoletusapi-worker.dev5014.workers.dev',
  print_scheduling_service: prefix + 'schedulerprintagentapi-worker.dev5014.workers.dev',
  // Worker Cloudflare do programa de indicacoes (repo Actuar/indicationsapi-worker).
  // MESMA URL nos cinco ambientes: o Worker e um so, sem par de stg/prd. Quando houver, o lugar
  // de separar e aqui — o front nunca monta esta URL a mao.
  // Dominio proprio `prd.cfw`, no formato do `suggestion_service`, em vez do `workers.dev` gerado.
  indications_service: prefix + 'indicationsworker-api.prd.cfw.actuar.cloud',
};

// export const API_PRODUCTION_ACTUAR = {
//   odata: prefix +'odata.prd.g.actuar.cloud',
//   odata_goods_service: prefix +'goodservice-api.prd.g.actuar.cloud/Odata',
//   odata_person_service: prefix +'personservice-api.prd.g.actuar.cloud/Odata',
//   odata_payable_service: prefix +'payableservice-api.prd.g.actuar.cloud/Odata',
//   odata_work_service: prefix +'workservice-api.prd.g.actuar.cloud/Odata',
//   odata_crm_service: prefix +'crmservice-api.prd.g.actuar.cloud/Odata',
//   odata_generalfinance_service: prefix + 'generalfinanceservice-api.prd.g.actuar.cloud/Odata',
//   odata_account_service: prefix + 'accountservice-api.prd.g.actuar.cloud/Odata',
//   odata_receivable_service: prefix +'receivableservice-api.prd.g.actuar.cloud/Odata',
//   odata_email_service: prefix +'emailservice-api.prd.g.actuar.cloud/Odata',
//   odata_contract: prefix +'contractservice-api.prd.g.actuar.cloud/Odata',
//   odata_user_service: prefix + 'userservice-api.prd.g.actuar.cloud/Odata',
//   odata_workout_service: prefix + 'workoutservice-api.prd.g.actuar.cloud/Odata',
//   odata_post_service: prefix + 'postservice-api.prd.g.actuar.cloud/Odata',
//   odata_activity_service: prefix + 'activityservice-api.prd.g.actuar.cloud/Odata',
//   odata_addresses_service: prefix + 'addressservice-api.prd.g.actuar.cloud/Odata',
//   base: prefix +'actuar-api.prd.g.actuar.cloud',
//   paguela: prefix +'paguela-api.prd.g.actuar.cloud',
//   api_cep: prefix +'cep-api.prd.g.actuar.cloud',
//   auth: prefix +'authentication-api.prd.actuar.biz',
//   chat: prefix +'tst.actuar.net/chat',
//   file_manager: prefix +'filegroup-api.prd.g.actuar.cloud',
//   treino: prefix +'treino-api.prd.g.actuar.cloud',
//   facial: prefix +'facial-api.prd.g.actuar.cloud',
//   acesso: prefix +'acesso-api.prd.g.actuar.cloud',
//   caixa: prefix +'caixa-api.prd.g.actuar.cloud',
//   helpdesk: prefix +'helpdesk-api.prd.g.actuar.cloud',
//   ajustes: prefix +'tst.actuar.net/actuar',
//   files_api: prefix +'files-api.prd.g.actuar.cloud',
//   contract: prefix +'contractservice-api.prd.g.actuar.cloud',
//   billing: prefix +'billing-api.prd.g.actuar.cloud',
//   gympass: prefix +'gympass-api.prd.g.actuar.cloud',
//   client_notification: prefix +'clientnotification-api.prd.g.actuar.cloud',
//   invoicer: prefix +'invoicer-api.prd.g.actuar.cloud',
//   acessoLocalhost: 'localhost:63312',
//   userService: prefix +'userservice-api.prd.g.actuar.cloud',
//   personService: prefix +'personservice-api.prd.g.actuar.cloud',
//   file_group: prefix +'filegroup-api.prd.g.actuar.cloud',
//   account_service: prefix + 'accountservice-api.prd.g.actuar.cloud',
//   goods: prefix + 'goodservice-api.prd.g.actuar.cloud',
//   payable_service: prefix + 'payableservice-api.prd.g.actuar.cloud',
//   workService: prefix + 'workservice-api.prd.g.actuar.cloud',
//   crm_service: prefix + 'crmservice-api.prd.g.actuar.cloud',
//   generalfinance_service: prefix + 'generalfinanceservice-api.prd.g.actuar.cloud',
//   receivable_service: prefix + 'receivableservice-api.prd.g.actuar.cloud',
//   subscription_service: prefix + 'subscriptionservice-api.prd.g.actuar.cloud',
//   email_service: prefix + 'emailservice-api.prd.g.actuar.cloud',
//   workout_service: prefix + 'workoutservice-api.prd.g.actuar.cloud',
//   workout_view: prefix + 'workoutviewservice-api.prd.g.actuar.cloud',
//   post_service: prefix + 'postservice-api.prd.g.actuar.cloud',
//   activity_service: prefix + 'activityservice-api.prd.g.actuar.cloud',
//   booking_service: prefix + 'bookingservice-api.prd.g.actuar.cloud',
//   data_service: prefix + 'dataservice-api.prd.g.actuar.cloud',
//   addresses_service: prefix + 'addressservice-api.prd.g.actuar.cloud',
//   physical_assessment_service: prefix + 'physicalassessmentservice-api.prd.g.actuar.cloud',
// }
